import { createReducer } from 'Helpers/redux'
import { FeedTrack, Review, FeedDetails } from 'Types/index'
import {
  GET_FEED_TRACKS,
  GET_REVIEWED_FEED_TRACKS,
  GET_FEED_DETAILS,
  SET_IS_RESERVED,
} from '../actions/feedActions'

export interface FeedCampaignsState {
  tracks: Array<FeedTrack>
  reviewedTracks: Array<Review>
  tracksPageCount: number
  reviewedTracksPageCount: number
  totalFeed: number
  totalReviewed: number
  feedDetails: FeedDetails
  isTimeUp: boolean
  isLimitReached: boolean
}

const initialState: FeedCampaignsState = {
  tracks: [],
  reviewedTracks: [],
  tracksPageCount: 0,
  reviewedTracksPageCount: 0,
  totalFeed: 0,
  totalReviewed: 0,
  // @ts-ignore
  feedDetails: {},
  isTimeUp: false,
  isLimitReached: false,
}

const handlers = {
  [GET_FEED_TRACKS.SUCCESS]: (
    prevState: FeedCampaignsState,
    {
      payload,
    }: {
      payload: {
        reviews: Array<FeedTrack>
        pageCount: number
        total: number
        currentPage: number
        limitReached: boolean
      }
    }
  ) => ({
    ...prevState,
    tracks:
      payload.currentPage === 1
        ? payload.reviews
        : [...prevState.tracks, ...payload.reviews],
    tracksPageCount: payload.pageCount,
    totalFeed: payload.total,
    isLimitReached: payload.limitReached,
  }),
  [GET_REVIEWED_FEED_TRACKS.SUCCESS]: (
    prevState: FeedCampaignsState,
    {
      payload,
    }: {
      payload: {
        reviews: Array<Review>
        pageCount: number
        total: number
        currentPage: number
      }
    }
  ) => ({
    ...prevState,
    reviewedTracks:
      payload.currentPage === 1
        ? payload.reviews
        : [...prevState.reviewedTracks, ...payload.reviews],
    reviewedTracksPageCount: payload.pageCount,
    totalReviewed: payload.total,
  }),
  [GET_FEED_DETAILS.SUCCESS]: (
    prevState: FeedCampaignsState,
    {
      payload,
    }: {
      payload: FeedDetails
    }
  ) => ({
    ...prevState,
    feedDetails: payload,
  }),
  [SET_IS_RESERVED]: (prevState: FeedCampaignsState) => ({
    ...prevState,
    feedDetails: {
      ...prevState.feedDetails,
      isReserved: true,
    },
  }),
}

export default createReducer(initialState, handlers)
